<div fxLayout="column" class="height-100">
  <div>
    <h1 mat-dialog-title fxLayout fxLayoutAlign="space-between center" class="no-margin">
      <div id="id_wizard_form_title" mat-typography>
        <!-- {{ (data.mode != 'edit' ? 'LABEL_ADD_NEW' : 'LABEL_EDIT_TYPE') | translate: { type: 'LABEL_CAMPAIGN' | translate } }} -->
        {{ 'LABEL_WIZARD' | translate }}
      </div>

      <div>
        <button id="id_close_form_btn" mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)='close()'>
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </h1>
  </div>

  <div fxFlex class="stepperTop height-100">
    <mat-horizontal-stepper #stepper class="height-100" [class.disable-overflow]="autoCompleteFieldOpen()" (selectionChange)="handleSelectionChange($event)">
      <!-- Campaign -->
      <mat-step completed="false">
        <ng-template matStepLabel>
          <span id="id_campaign_step_lbl">Campaign</span>
        </ng-template>

        <esc-step-one 
          #stepOne
          [viewMode]="viewMode"
          [editMode]="editMode"
          [campaignData]="selectedCampaign"
          [isDisabled]="disableStepOneForm"
          [loadingCampaign]="loadingCampaign"
          [status]="data?.campaign_distribution_data != null ? data?.campaign_distribution_data.status : 'new'"
          >
        </esc-step-one>

        <div class="padding-top-2;" fxLayoutAlign="end center">
          <button id="id_next_form_btn" mat-stroked-button color="primary" (click)="validateStepOne()">
            {{ 'LABEL_NEXT' | translate }}
          </button>
        </div>
      </mat-step>

      <!-- Distribution -->
      <mat-step completed="false">
        <ng-template matStepLabel>
          <span id="id_dist_step_lbl">
            Distribution
          </span>
        </ng-template>
        
        <esc-step-two 
          #stepTwo
          [viewMode]="viewMode"
          [campaignData]="selectedCampaign" 
          [distributionData]="selectedDistribution" 
          [loadingDistribution]="loadingDistribution"
          [campaignDataFromList]="data?.campaign_distribution_data"
          [editMode]="data?.mode == 'edit' ? true : false"
          [status]="data?.campaign_distribution_data != null ? data?.campaign_distribution_data.status : 'new'"
          [did_generate]="data?.campaign_distribution_data?.did_generate"
          >
        </esc-step-two>

        <div class="padding-top-2;" fxLayoutGap="10px" fxLayoutAlign="end center">
          <button id="id_back_form_btn" mat-stroked-button color="primary" (click)="confirmBackStep()" *ngIf="stepper.selectedIndex == 1">
            {{ 'LABEL_BACK' | translate }}
          </button>
          <button id="id_next_form_btn" mat-stroked-button color="primary" *ngIf="!viewMode" (click)="validateStepTwo()">
            {{ 'LABEL_NEXT' | translate }}
          </button>
          <button id="id_next_form_btn" mat-stroked-button color="primary" *ngIf="viewMode" (click)="stepThree.getConditions(); stepper.next()">
            {{ 'LABEL_NEXT' | translate }}
          </button>
        </div>
      </mat-step>

      <!-- Condition -->
      <mat-step completed="false">
        <ng-template matStepLabel>
          <span id="id_condition_step_lbl">
            Condition
          </span>
        </ng-template>

        <esc-step-three 
          #stepThree
          [viewMode]="viewMode"
          [did_generate]="data?.campaign_distribution_data?.did_generate"
          [distributionData]="selectedDistribution" 
          [status]="data?.campaign_distribution_data != null ? data?.campaign_distribution_data.status : 'new'"
          >
        </esc-step-three>

        <div class="padding-top-2;" fxLayoutGap="10px" fxLayoutAlign="end center">
          <button mat-stroked-button color="primary" (click)="confirmBackStepThree()">
            {{ 'LABEL_BACK' | translate }}
          </button>
          <button mat-stroked-button color="primary" *ngIf="!viewMode" (click)="validateStepThree()">
            {{ 'LABEL_SAVE' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>